/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Cut': {
    width: 24,
    height: 22,
    viewBox: '0 0 24 22',
    data: '<path pid="0" d="M23.9 3.692c-1.104-1.584-3.3-2.002-4.877-.893l-8.111 5.704-2.95-2.075A4.296 4.296 0 006.715.775 4.256 4.256 0 00.772 1.828 4.297 4.297 0 001.82 7.796a4.251 4.251 0 004.347.327l3.613 2.54-3.612 2.54a4.253 4.253 0 00-4.348.327 4.297 4.297 0 00-1.048 5.968 4.256 4.256 0 005.944 1.053 4.296 4.296 0 001.246-5.653l2.95-2.074 8.11 5.702c1.578 1.11 3.774.692 4.878-.892l-9.915-6.97L23.9 3.691zM4.277 6.516a2.217 2.217 0 01-2.212-2.221c0-1.227.99-2.221 2.212-2.221 1.222 0 2.212.994 2.212 2.221S5.5 6.516 4.277 6.516zm0 12.737a2.217 2.217 0 01-2.212-2.221c0-1.227.99-2.222 2.212-2.222 1.222 0 2.212.995 2.212 2.222 0 1.226-.99 2.221-2.212 2.221z" _fill="#243143" fill-opacity=".4"/>'
  }
})
